import { useEffect, useState } from "react";
// import axios from 'axios';
import { ArrowDownTrayIcon, PrinterIcon, WrenchScrewdriverIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Actions as EMPLOYEEACTIONS } from "../../store/actions/employeeActions";
import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import { Actions as PERMISSIONACTIONS } from "../../store/actions/permissionActions";
import Spinner from "../common/Spinner";
import ArchivedCompany from "../company-pages/ArchivedCompany";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import UpgradeRequired from "../company-pages/UpgradeRequired";
import LeaveAdjustment from "./LeaveAdjustment";
import LeaveBalances from "./LeaveBalances";
import LeaveCarryover from "./LeaveCarryover";
import TeamLeave from "./TeamLeave";
import Timeline from "./Timeline";

import { addMonths, format } from "date-fns";

const tabs = [
	{
		link: "/organisation/leave/applications",
		name: "Applications",
	},
	{
		link: "/organisation/leave/balances",
		name: "Balances",
	},
	{
		link: "/organisation/leave/timeline",
		name: "Timeline",
	},
	{
		link: "/organisation/leave/adjustments",
		name: "Adjustments",
	},
];

const Leave = ({
	getLeaveTypes,
	getLeaveSettings,
	employeesGetListWithSalary,
	tab,
	leaveTab,
	setOpenModal,
	leaveReportUpdating,
	leaveGetBalances,
	showLeaveBalanceReportModal,
	getOrganisationDetails,
	getMyPermissions,
	userPermissions,
	settingsPermissions,
	includedInPlan,
	isDemo,
	org,
	archivedStatus,
}) => {
	const location = useLocation();
	const currentTab = location.pathname;

	const leaveBalanceClass = leaveReportUpdating ? (
		<Spinner
			style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
			className="animate-spin -ml-1 mr-3 h-5 w-5 "
		/>
	) : (
		<ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
	);

	useEffect(() => {
		getLeaveTypes();
		getLeaveSettings();
		employeesGetListWithSalary();
		leaveGetBalances();
		return () => {};
	}, []);

	if (archivedStatus == "Archived") return <ArchivedCompany />;
	if (!includedInPlan && !isDemo) return <UpgradeRequired />;
	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<>
			{userPermissions != "Read" && <LeaveCarryover />}
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="pull-left">
						<h1 className="page-heading">Leave</h1>
					</div>
					{settingsPermissions != "None" && (
						<Link
							className="btn btn-default pull-right"
							to="/organisation/settings/leave"
							style={{ marginLeft: 10 }}
						>
							<WrenchScrewdriverIcon style={{ height: "1.5em", float: "left" }} />
						</Link>
					)}
					<div
						className="btn btn-default pull-right"
						style={{ marginLeft: 10 }}
						onClick={() => showLeaveBalanceReportModal()}
					>
						{leaveBalanceClass}
						<div style={{ float: "left" }}>Leave Situation Report</div>
					</div>
					<div
						className="btn btn-default pull-right"
						onClick={window.print}
					>
						<PrinterIcon style={{ height: "1.5em", float: "left" }} />
					</div>
				</div>
			</div>
			<div>
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>
			</div>
			<div className="mb-32">
				<Routes>
					<Route
						path="applications"
						element={<TeamLeave />}
					/>
					<Route
						path="timeline"
						element={<Timeline />}
					/>
					<Route
						path="balances"
						element={<LeaveBalances />}
					/>
					<Route
						path="adjustments"
						element={<LeaveAdjustment />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/organisation/leave/applications"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.leave;
	const settingsPermissions = state?.permissions?.my?.permissions?.settings;

	return {
		tab: state.leave.tab || "applications",
		org: state?.company?.settings.org,
		isDemo: state?.company?.settings.isDemo,
		leaveReportUpdating: state.leaveleaveReportUpdating,
		userPermissions,
		includedInPlan: state.permissions?.plan?.leave,
		settingsPermissions,
		archivedStatus: state?.company?.settings?.status,
	};
};

const twoMonthsAgo = addMonths(new Date(), -2);

const mapDispatchToProps = (dispatch) => ({
	getMyPermissions: () => dispatch(PERMISSIONACTIONS.getMyPermissions()),
	getLeaveTypes: () => dispatch(LEAVEACTIONS.getLeaveTypes()),
	getLeaveSettings: () => dispatch(LEAVEACTIONS.getLeaveSettings()),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from:
						format(twoMonthsAgo, "yyyy") == format(new Date(), "yyyy")
							? format(new Date(), "yyyy-01-01")
							: format(twoMonthsAgo, "yyyy-MM-01"), // get list from 2 months prior to start of year
					to: format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
	leaveGetBalances: () => dispatch(LEAVEACTIONS.leaveGetBalances(format(new Date(), "yyyy-MM-dd"))),

	setOpenModal: (status, leave) => dispatch(LEAVEACTIONS.setOpenModal(status, leave)),
	showLeaveBalanceReportModal: () => dispatch(LEAVEACTIONS.showLeaveBalanceReportModal(true)),
	leaveTab: (tab) => dispatch(LEAVEACTIONS.leaveTab(tab)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Leave);
